import DecodeQuill from './header/decode'
import EncodeQuill from './header/encode'
import { createQuillModules } from './header/quill'
export default {
    namespaced: true,
    state: {
        quill: {
            encode: new EncodeQuill(),
            decode: new DecodeQuill(),
            modules: createQuillModules()
        },
        editor: {
            max_inline_chars: '40',
            header: '',
            editor_content_length: 0
        },
        fiscalization_wizard: {
            cashRegister: {
                cash_register_id: null,
                bill_counter_reset_after_rd: false,
                device_id: "",
                user_name: "Kierownik",
                user_passwd: "1234",
                currency: "PLN",
                usage_type: "4",
                ownership_type: "5",
                end_user_taxid: "",
                end_user_tax_office_code: "",
                location_id: "",
                cash_type: "Wirtualna",
                vat_rates: {
                    a: { type: "value", value: "23" },
                    b: { type: "value", value: "8" },
                    c: { type: "value", value: "5" },
                    d: { type: "value", value: "0" },
                    e: { type: "zw", value: "" },
                    f: { type: "notactive", value: "" },
                    g: { type: "notactive", value: "" }
                },
                header: ""
            },
            device: {}
        },
        test_mode: true,
        is_loaded_from_file: false
    },
    getters: {
        header: state => state.editor.header,
        fiscalization_wizard: state => state.fiscalization_wizard,
        max_inline_chars: state => state.editor.max_inline_chars,
        editor_content_length: state => state.editor.editor_content_length,
        is_loaded_from_file: state => state.is_loaded_from_file
    },
    mutations: {
        set_header: (state, payload) => {
            state.editor.header = payload
        },
        change_space_for_hard_space: (state) => {
            const pattern = ' '
            let counter = 0
            let result = null
            let changed_header = state.editor.header
            do {
                result = changed_header.indexOf(pattern, counter)
                if (result !== -1 && changed_header[result - 1] !== 'p' && changed_header[result - 2] !== '<') { // replace all white spaces but do not change <p class...
                    let array_of_chars = [...changed_header]
                    array_of_chars[result] = '&#160;'
                    changed_header = array_of_chars.join('')
                }
                counter++
            } while (result !== -1)
            state.editor.header = changed_header
        },
        set_max_inline_chars: (state, payload) => (state.editor.max_inline_chars = payload),
        set_fiscalization_wizard: (state, payload) => (state.fiscalization_wizard = payload),
        set_test_mode: (state, payload) => (state.test_mode = payload),
        set_editor_content_length: (state, payload) => (state.editor.editor_content_length = payload),
        set_is_loaded_from_file: (state, payload) => (state.is_loaded_from_file = payload),
        set_default_max_inline_chars: (state, value) => (state.editor.max_inline_chars = '40'),
        set_default_fiscalization_wizard: (state) => (
            state.fiscalization_wizard = {
                cashRegister: {
                    cash_register_id: null,
                    bill_counter_reset_after_rd: false,
                    device_id: "",
                    user_name: "Kierownik",
                    user_passwd: "1234",
                    currency: "PLN",
                    usage_type: "4",
                    ownership_type: "5",
                    end_user_taxid: "",
                    end_user_tax_office_code: "",
                    location_id: "",
                    cash_type: "Wirtualna",
                    vat_rates: {
                        a: { type: "value", value: "23" },
                        b: { type: "value", value: "8" },
                        c: { type: "value", value: "5" },
                        d: { type: "value", value: "0" },
                        e: { type: "zw", value: "" },
                        f: { type: "notactive", value: "" },
                        g: { type: "notactive", value: "" }
                    },
                    header: ""
                },
                device: {}
            },
            state.editor.header = ''
        )
    },
    actions: {
        write_header: ({ state, commit, rootGetters }) => {
            const encode_header = state.quill.encode.editor(state.editor.header)
            return rootGetters['backend/device']
                .set_header(encode_header, state.test_mode)
                .then(response => {
                    commit('backend/set_response', response, { root: true })
                    return response
                })
        },
        read_header: ({ state, commit, rootGetters }) =>
            rootGetters['backend/device']
            .get_header()
            .then(response => {
                const { tx } = response
                const data = state.quill.decode.editor(tx, rootGetters['backend/device'].meta.device_definition.programming.header.formatting)
                commit('set_header', data)
                commit('change_space_for_hard_space')
                commit('backend/set_response', response, { root: true })
                return response
            })
    }
}